import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useTranslation } from '../lib/i18n';
export function NotFoundPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-[80vh] flex items-center justify-center bg-dark-bg px-4 sm:px-6 lg:px-8 py-20" data-id="element-901">
      <div className="max-w-2xl mx-auto text-center" data-id="element-902">
        <div className="text-[120px] md:text-[180px] font-black leading-none text-brand-yellow mb-4 tracking-tighter" data-id="element-903">
          404
        </div>
        <div className="w-16 h-1 bg-brand-yellow rounded-full mx-auto mb-8" data-id="element-904" />
        <h1 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-905">
          {en ? 'Page not found' : ru ? 'Страница не найдена' : 'Stranica nije pronađena'}
        </h1>
        <p className="text-lg text-gray-400 mb-10 max-w-md mx-auto" data-id="element-906">
          {en ? 'The page you are looking for does not exist or has been moved.' : ru ? 'Запрашиваемая страница не существует или была перемещена.' : 'Stranica koju tražite ne postoji ili je premeštena.'}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-907">
          <Link to="/" data-id="element-908">
            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-909">
              <HomeIcon className="w-5 h-5 mr-2" data-id="element-910" />
              {en ? 'Back to home' : ru ? 'На главную' : 'Na početnu stranicu'}
            </Button>
          </Link>
          <Link to="/products" data-id="element-911">
            <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-912">
              <ArrowLeftIcon className="w-5 h-5 mr-2" data-id="element-913" />
              {en ? 'View products' : ru ? 'Посмотреть продукты' : 'Pogledajte proizvode'}
            </Button>
          </Link>
        </div>
      </div>
    </main>;
}